import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';

/**
 * Prymitywy tabeli.
 *
 * Celowo nie budujemy tu tabeli sterowanej danymi — sortowanie, paginacja
 * i wirtualizacja to odpowiedzialnosc warstwy funkcjonalnosci. Tutaj jest
 * wylacznie warstwa wizualna zgodna z makietami.
 */

/** Kontener zapewniajacy poziome przewijanie na waskich ekranach. */
export function TableContainer({ className, ...props }: ComponentPropsWithRef<'div'>) {
  return (
    <div
      className={cn('border-border bg-surface w-full overflow-x-auto rounded-xl border', className)}
      {...props}
    />
  );
}

export function Table({ className, ...props }: ComponentPropsWithRef<'table'>) {
  return <table className={cn('w-full border-collapse text-sm', className)} {...props} />;
}

export function TableHead({ className, ...props }: ComponentPropsWithRef<'thead'>) {
  return <thead className={cn('bg-surface-sunken', className)} {...props} />;
}

export function TableBody({ className, ...props }: ComponentPropsWithRef<'tbody'>) {
  return <tbody className={className} {...props} />;
}

export function TableRow({ className, ...props }: ComponentPropsWithRef<'tr'>) {
  return (
    <tr
      className={cn(
        'border-border border-b transition-colors last:border-b-0 hover:bg-surface-hover',
        className,
      )}
      {...props}
    />
  );
}

export function TableHeaderCell({ className, ...props }: ComponentPropsWithRef<'th'>) {
  return (
    <th
      scope="col"
      className={cn(
        'text-fg-muted border-border border-b px-4 py-3 text-left',
        'text-[0.6875rem] font-semibold tracking-[0.06em] uppercase',
        className,
      )}
      {...props}
    />
  );
}

export function TableCell({ className, ...props }: ComponentPropsWithRef<'td'>) {
  return <td className={cn('text-fg px-4 py-3 align-middle', className)} {...props} />;
}

/** Stopka tabeli — np. „Wyświetlanie 1-32 z 32 zawodników”. */
export function TableFooter({ className, ...props }: ComponentPropsWithRef<'div'>) {
  return (
    <div
      className={cn('text-fg-subtle border-border border-t px-4 py-3 text-center text-xs', className)}
      {...props}
    />
  );
}
